import React from 'react';
import { Direction } from '@prisjakt/ui';
import { Dropdown, DropdownContent } from '@prisjakt/ui/dropdown';
import { ButtonSize } from '@prisjakt/ui/button';
import { Behavior } from '@prisjakt/ui/text';
import { zindex } from 'src/ui/zindex';
import { SizeVariantsButtonLabel } from './size-variants-button-label';
import { SizeVariantsGrid } from './size-variants-grid';
import type { IVariantsProps } from '../types';
import { DropdownToggle, DropdownButtonText } from '../styles-common';

export const SizeVariantsDesktopVersion: React.FC<IVariantsProps> = props => {
  return (
    <Dropdown zIndex={zindex.overlay}>
      <DropdownToggle showActiveIcon fullWidth size={ButtonSize.SMALL}>
        <DropdownButtonText behavior={Behavior.OnelineEllipsis}>
          <SizeVariantsButtonLabel />
        </DropdownButtonText>
      </DropdownToggle>
      <DropdownContent alignment={Direction.Down}>
        <SizeVariantsGrid {...props} />
      </DropdownContent>
    </Dropdown>
  );
};
